// E-DEP Compatible Countries List - Generated from database
// This file serves as a fallback when the API is unavailable

export interface Country {
  code: string;
  nameFr: string;
  nameAr?: string;
  nameEn?: string;
  nationality?: string;
}

export const countries: Country[] = [
  { code: 'MA', nameFr: 'Maroc' },
  { code: 'AF00', nameFr: 'Afghanistan' },
  { code: 'AL01', nameFr: 'Albanie' },
  { code: 'DZ', nameFr: 'Algérie' },
  { code: 'SA03', nameFr: 'Samoa orientales (téritoire USA)' },
  { code: 'AN04', nameFr: 'Andorre' },
  { code: 'AN05', nameFr: 'Angola' },
  { code: 'AN06', nameFr: 'Anguilla' },
  { code: 'AN07', nameFr: 'Antarctique' },
  { code: 'AN08', nameFr: 'Antigua-et-Barbuda' },
  { code: 'AR09', nameFr: 'Argentine' },
  { code: 'AR10', nameFr: 'Arménie' },
  { code: 'AR11', nameFr: 'Aruba' },
  { code: 'AU12', nameFr: 'Australie' },
  { code: 'AU13', nameFr: 'Autriche' },
  { code: 'AZ14', nameFr: 'Azerbaïdjan' },
  { code: 'BA15', nameFr: 'Bahamas' },
  { code: 'BA16', nameFr: 'Bahreïn' },
  { code: 'BA17', nameFr: 'Bangladesh' },
  { code: 'BA18', nameFr: 'Barbade' },
  { code: 'BE19', nameFr: 'Bélarus' },
  { code: 'BE', nameFr: 'Belgique' },
  { code: 'BE21', nameFr: 'Bélize' },
  { code: 'BE22', nameFr: 'Bénin' },
  { code: 'BE23', nameFr: 'Bermudes' },
  { code: 'BH24', nameFr: 'Bhoutan' },
  { code: 'BO25', nameFr: 'Bolivie' },
  { code: 'BO26', nameFr: 'Bosnie-Herzégovine' },
  { code: 'BO27', nameFr: 'Botswana' },
  { code: 'BO28', nameFr: 'Bouvet (Île) (téritoire norvégien)' },
  { code: 'BR', nameFr: 'Brésil' },
  { code: 'TE30', nameFr: 'Territoire britannique de l\'Océan Indien' },
  { code: 'BR31', nameFr: 'Brunéi Darussalam' },
  { code: 'BU32', nameFr: 'Bulgarie' },
  { code: 'BU33', nameFr: 'Burkina Faso' },
  { code: 'BU34', nameFr: 'Burundi' },
  { code: 'CA35', nameFr: 'Cambodge' },
  { code: 'CM', nameFr: 'Cameroun' },
  { code: 'CA', nameFr: 'Canada' },
  { code: 'CA38', nameFr: 'Cap Vert' },
  { code: 'CA39', nameFr: 'Caïmans (Îles)' },
  { code: 'RE40', nameFr: 'République Centrafricaine' },
  { code: 'TC41', nameFr: 'Tchad' },
  { code: 'CH42', nameFr: 'Chili' },
  { code: 'CN', nameFr: 'Chine' },
  { code: 'CH44', nameFr: 'Christmas (Île) (téritoire australie)' },
  { code: 'CO45', nameFr: 'Cocos / Keeling (Îles) téritoire australien' },
  { code: 'CO46', nameFr: 'Colombie' },
  { code: 'CO47', nameFr: 'Comores' },
  { code: 'CO48', nameFr: 'Congo' },
  { code: 'RE49', nameFr: 'République Démocratique du Congo' },
  { code: 'CO50', nameFr: 'Cook (Îles)' },
  { code: 'CO51', nameFr: 'Costa Rica' },
  { code: 'CI', nameFr: 'Côte D\'Ivoire' },
  { code: 'CR53', nameFr: 'Croatie' },
  { code: 'CU54', nameFr: 'Cuba' },
  { code: 'CH55', nameFr: 'Chypre' },
  { code: 'RE56', nameFr: 'République Tchèque' },
  { code: 'DA57', nameFr: 'Danemark' },
  { code: 'DJ58', nameFr: 'Djibouti' },
  { code: 'DO59', nameFr: 'Dominique' },
  { code: 'RE60', nameFr: 'République Dominicaine' },
  { code: 'TI61', nameFr: 'Timor-Oriental' },
  { code: 'EQ62', nameFr: 'Equateur' },
  { code: 'EG', nameFr: 'Egypte' },
  { code: 'EL64', nameFr: 'El Salvador' },
  { code: 'GU65', nameFr: 'Guinée Equatoriale' },
  { code: 'ER66', nameFr: 'Erythrée' },
  { code: 'ES67', nameFr: 'Estonie' },
  { code: 'ET68', nameFr: 'Ethiopie' },
  { code: 'FA69', nameFr: 'Falkland / Malouines (Îles) téritoire royaum uni' },
  { code: 'FE70', nameFr: 'Féroé (Îles) Danoise' },
  { code: 'FI71', nameFr: 'Fidji' },
  { code: 'FI72', nameFr: 'Finlande' },
  { code: 'FR', nameFr: 'France' },
  { code: 'FR074', nameFr: 'France métropolitaine' },
  { code: 'GU75', nameFr: 'Guyane française' },
  { code: 'PO76', nameFr: 'Polynésie française' },
  { code: 'TE77', nameFr: 'Territoires Antarctiques français' },
  { code: 'GA78', nameFr: 'Gabon' },
  { code: 'GA79', nameFr: 'Gambie' },
  { code: 'GE80', nameFr: 'Géorgie' },
  { code: 'DE', nameFr: 'Allemagne' },
  { code: 'GH82', nameFr: 'Ghana' },
  { code: 'GI83', nameFr: 'Gibraltar' },
  { code: 'GR84', nameFr: 'Grèce' },
  { code: 'GR85', nameFr: 'Groënland (téritoire danois)' },
  { code: 'GR86', nameFr: 'Grenade' },
  { code: 'GU87', nameFr: 'Guadeloupe  (téritoire Français)' },
  { code: 'GU88', nameFr: 'Guam (USA)' },
  { code: 'GU89', nameFr: 'Guatemala' },
  { code: 'GU90', nameFr: 'Guinée' },
  { code: 'GU91', nameFr: 'Guinée-Bissau' },
  { code: 'GU92', nameFr: 'Guyana' },
  { code: 'HA93', nameFr: 'Haïti' },
  { code: 'TE94', nameFr: 'Territoire des Îles Heard et McDonald (Australie)' },
  { code: 'VA95', nameFr: 'Vatican' },
  { code: 'HO96', nameFr: 'Honduras' },
  { code: 'HO97', nameFr: 'Hong Kong' },
  { code: 'HO98', nameFr: 'Hongrie' },
  { code: 'IS99', nameFr: 'Islande' },
  { code: 'IN', nameFr: 'Inde' },
  { code: 'IN101', nameFr: 'Indonésie' },
  { code: 'IR102', nameFr: 'Iran (République islamique d\'Iran)' },
  { code: 'IR103', nameFr: 'Iraq' },
  { code: 'IR104', nameFr: 'Irlande' },
  { code: 'IT', nameFr: 'Italie' },
  { code: 'JA106', nameFr: 'Jamaïque' },
  { code: 'JP', nameFr: 'Japon' },
  { code: 'JO108', nameFr: 'Jordanie' },
  { code: 'KA109', nameFr: 'Kazakstan' },
  { code: 'KE110', nameFr: 'Kenya' },
  { code: 'KI111', nameFr: 'Kiribati' },
  { code: 'CO112', nameFr: 'Corée (République populaire démocratique du)' },
  { code: 'CO113', nameFr: 'Corée (République démocratique du)' },
  { code: 'KO114', nameFr: 'Koweït' },
  { code: 'KY115', nameFr: 'Kyrgyzstan' },
  { code: 'LA116', nameFr: 'Lao (République populaire démocratique du)' },
  { code: 'LE117', nameFr: 'Lettonie' },
  { code: 'LI118', nameFr: 'Liban' },
  { code: 'LE119', nameFr: 'Lesotho' },
  { code: 'LI120', nameFr: 'Libéria' },
  { code: 'LI121', nameFr: 'Libye' },
  { code: 'LI122', nameFr: 'Liechtenstein' },
  { code: 'LI123', nameFr: 'Lithuanie' },
  { code: 'LU124', nameFr: 'Luxembourg' },
  { code: 'CN125', nameFr: 'Chine, région administrative spéciale de Macao' },
  { code: 'MA126', nameFr: 'Macédoine (ancienne République yougoslave de)' },
  { code: 'MA127', nameFr: 'Madagascar' },
  { code: 'MA128', nameFr: 'Malawi' },
  { code: 'MA129', nameFr: 'Malaisie' },
  { code: 'MA130', nameFr: 'Maldives' },
  { code: 'MA131', nameFr: 'Mali' },
  { code: 'MA132', nameFr: 'Malte' },
  { code: 'MA133', nameFr: 'Marshall (Îles)' },
  { code: 'MA134', nameFr: 'Martinique (téritoire Français)' },
  { code: 'MA135', nameFr: 'Mauritanie' },
  { code: 'MA136', nameFr: 'Maurice' },
  { code: 'MA137', nameFr: 'Mayotte  (téritoire Français)' },
  { code: 'MX', nameFr: 'Mexique' },
  { code: 'MI139', nameFr: 'Micronésie (Etats fédérés de)' },
  { code: 'MO140', nameFr: 'Moldavie' },
  { code: 'MO141', nameFr: 'Monaco' },
  { code: 'MO142', nameFr: 'Mongolie' },
  { code: 'MO143', nameFr: 'Montserrat' },
  { code: 'MO145', nameFr: 'Mozambique' },
  { code: 'MY146', nameFr: 'Myanmar' },
  { code: 'NA147', nameFr: 'Namibie' },
  { code: 'NA148', nameFr: 'Nauru' },
  { code: 'NE149', nameFr: 'Népal' },
  { code: 'NL', nameFr: 'Pays-Bas' },
  { code: 'AN151', nameFr: 'Antilles néerlandaises' },
  { code: 'NO152', nameFr: 'Nouvelle-Calédonie' },
  { code: 'NO153', nameFr: 'Nouvelle-Zélande' },
  { code: 'NI154', nameFr: 'Nicaragua' },
  { code: 'NI155', nameFr: 'Niger' },
  { code: 'NI156', nameFr: 'Nigéria' },
  { code: 'NI157', nameFr: 'Niue' },
  { code: 'NO158', nameFr: 'Norfolk (Île) (téritoire australie)' },
  { code: 'MA159', nameFr: 'Mariannes (Îles)' },
  { code: 'NO160', nameFr: 'Norvège' },
  { code: 'OM161', nameFr: 'Oman' },
  { code: 'PA162', nameFr: 'Pakistan' },
  { code: 'PA163', nameFr: 'Palaos' },
  { code: 'PA164', nameFr: 'Panama' },
  { code: 'PA165', nameFr: 'Papouasie Nouvelle-Guinée' },
  { code: 'PA166', nameFr: 'Paraguay' },
  { code: 'PE167', nameFr: 'Pérou' },
  { code: 'PH168', nameFr: 'Philippines' },
  { code: 'PI169', nameFr: 'Pitcaïrn ( territoire britannique)' },
  { code: 'PO170', nameFr: 'Pologne' },
  { code: 'PT', nameFr: 'Portugal' },
  { code: 'PO172', nameFr: 'Porto Rico' },
  { code: 'QA', nameFr: 'Qatar' },
  { code: 'RE174', nameFr: 'Réunion (téritoire Français)' },
  { code: 'RO175', nameFr: 'Roumanie' },
  { code: 'RU', nameFr: 'Russie (Fédération de)' },
  { code: 'RU177', nameFr: 'Ruwanda' },
  { code: 'SA178', nameFr: 'Saint Kitts et Nevis' },
  { code: 'SA179', nameFr: 'Sainte Lucie' },
  { code: 'SA180', nameFr: 'Saint Vincent et Grenadines' },
  { code: 'SA181', nameFr: 'Samoa' },
  { code: 'SA182', nameFr: 'Saint-Marin' },
  { code: 'SA183', nameFr: 'Sao Tomé et Principe' },
  { code: 'SA', nameFr: 'Arabie Séoudite' },
  { code: 'SN', nameFr: 'Sénégal' },
  { code: 'SE186', nameFr: 'Seychelles' },
  { code: 'SI187', nameFr: 'Sierra Léone' },
  { code: 'SI188', nameFr: 'Singapour' },
  { code: 'SL189', nameFr: 'Slovaquie' },
  { code: 'SL190', nameFr: 'Slovénie' },
  { code: 'SA191', nameFr: 'Salomon (Îles)' },
  { code: 'SO192', nameFr: 'Somalie' },
  { code: 'AF193', nameFr: 'Afrique du Sud' },
  { code: 'GE194', nameFr: 'Géorgie du Sud et îles Sandwich du Sud ( territoire britannique)' },
  { code: 'ES', nameFr: 'Espagne' },
  { code: 'SR196', nameFr: 'Sri Lanka' },
  { code: 'ST197', nameFr: 'Ste Hélène ( territoire britannique)' },
  { code: 'ST198', nameFr: 'St. Pierre et Miquelon (téritoire Français)' },
  { code: 'SO199', nameFr: 'Soudan' },
  { code: 'SU200', nameFr: 'Surinam' },
  { code: 'SV201', nameFr: 'Svalbard et Jan Mayen (Îles) territoire de la Norvège' },
  { code: 'SW202', nameFr: 'Swaziland' },
  { code: 'SU203', nameFr: 'Suède' },
  { code: 'CH', nameFr: 'Suisse' },
  { code: 'SY205', nameFr: 'Syrie (République arabe syrienne)' },
  { code: 'CN206', nameFr: 'Taïwan (officiellement la république de Chine)' },
  { code: 'TA207', nameFr: 'Tadjikistan' },
  { code: 'TA208', nameFr: 'Tanzanie' },
  { code: 'TH209', nameFr: 'Thaïlande' },
  { code: 'TO210', nameFr: 'Togo' },
  { code: 'TO211', nameFr: 'Tokélaou' },
  { code: 'TO212', nameFr: 'Tonga' },
  { code: 'TR213', nameFr: 'Trinidad et Tobago' },
  { code: 'TN', nameFr: 'Tunisie' },
  { code: 'TU215', nameFr: 'Turquie' },
  { code: 'TU216', nameFr: 'Turkménistan' },
  { code: 'IL217', nameFr: 'Îles Turques et Caïques' },
  { code: 'TU218', nameFr: 'Tuvalu' },
  { code: 'OU219', nameFr: 'Ouganda' },
  { code: 'UK220', nameFr: 'Ukraine' },
  { code: 'AE', nameFr: 'Emirats Arabes Unis' },
  { code: 'GB', nameFr: 'Royaume-Uni' },
  { code: 'US', nameFr: 'Etats-Unis d\'Amérique' },
  { code: 'US224', nameFr: 'Territoires non incorporés des États-Unis' },
  { code: 'UR225', nameFr: 'Uruguay' },
  { code: 'OU226', nameFr: 'Ouzbékistan' },
  { code: 'VA227', nameFr: 'Vanuatu' },
  { code: 'VE228', nameFr: 'Vénézuela' },
  { code: 'VI229', nameFr: 'Viet Nam' },
  { code: 'VI230', nameFr: 'Vierges (Îles) - RU' },
  { code: 'VI231', nameFr: 'Vierges (Îles) - EU (USA)' },
  { code: 'WA232', nameFr: 'Wallis et Futuna (Îles) ( territoire français )' },
  { code: 'YE233', nameFr: 'Yemen' },
  { code: 'YO234', nameFr: 'Yougoslavie' },
  { code: 'ZA235', nameFr: 'Zambie' },
  { code: 'ZI236', nameFr: 'Zimbabwe' },
  { code: 'HA237', nameFr: 'Haut volta' },
  { code: 'SU238', nameFr: 'Sud-Soudan' },
  { code: 'CU239', nameFr: 'Curaçao' },
  { code: 'IL240', nameFr: 'Îles Vierges britanniques' },
  { code: 'IS241', nameFr: 'Israël' },
  { code: 'MO242', nameFr: 'Monténégro' },
  { code: 'SA243', nameFr: 'Saint-Martin (partie néerlandaise)' },
  { code: 'SA244', nameFr: 'Saint-Siège' },
  { code: 'SE245', nameFr: 'Serbie' },
  { code: 'PA246', nameFr: 'Palestine' },
  { code: 'PA247', nameFr: 'Pays non spécifié (afrique)' },
  { code: 'PA248', nameFr: 'Pays non spécifié' },
];

// Helper functions
export function getCountryByCode(code: string): Country | undefined {
  return countries.find(c => c.code === code);
}

export function getCountryName(code: string): string {
  const country = getCountryByCode(code);
  return country?.nameFr || code;
}

export function isMoroccan(code: string): boolean {
  return code === 'MA';
}
